import React, { useState } from 'react';
import Sidebar from 'components/Sidebar';
import MobileHeader from 'components/MobileHeader';
import SearchOverlay from 'components/SearchOverlay';
import Container from 'components/Container';
import { Link, useParams } from 'react-router-dom';
import { CaretLeftIcon } from '@phosphor-icons/react';
import { useQuery } from '@tanstack/react-query';
import { getUser, getUserPermissions } from 'api/users';
import LoadingOverlay from 'components/LoadingOverlay';
import UserEditPopup from 'components/UserEditPopup';
import Button from 'components/Button';

export default function User() {

    const [sidebar, setSidebar] = useState(false);
    const [search, setSearch] = useState(false);
    const [editUserPopup, setEditUserPopup] = useState(false);
    const { userId } = useParams();

    const { data: user, isLoading } = useQuery({
        queryKey: ['users', userId],
        queryFn: async () => await getUser({ id: userId }),
    });

    const { data: permissions, isLoading: isLoadingPermissions } = useQuery({
        queryKey: ['users', userId, 'permissions'],
        queryFn: async () => await getUserPermissions({ id: userId }),
    });

    const offices = permissions?.filter(p => p.elementType === 'offices')

    return (
        <>
            <Sidebar
                visible={sidebar}
                setVisible={setSidebar}
            />

            <SearchOverlay
                visible={search}
                setVisible={setSearch}
            />

            <MobileHeader
                sidebar={sidebar}
                setSidebar={setSidebar}
                search={search}
                setSearch={setSearch}
            />

            <LoadingOverlay isLoading={isLoading} />

            <div className={`fixed top-0 w-full bottom-0 transition-all duration-300 ease-in-out lg:pl-[320px] ${sidebar ? 'left-[80vw]' : 'left-0'}`}>
                <Container className='pb-20'>
                    <div className='pb-8 pt-20 md:pt-14 flex gap-3 items-center'>
                        <div className='flex-1 flex gap-3 items-center'>
                            <Link to="/settings/users" className=''>
                                <CaretLeftIcon size={26} className='hover:text-muted' />
                            </Link>
                            <p className='text-3xl'>Informazioni utente</p>
                        </div>
                        <Button onClick={() => setEditUserPopup(true)}>Modifica</Button>
                    </div>

                    <div className='flex gap-10'>
                        <div className='flex-1 border border-light rounded-sm'>
                            <div className='p-4'>
                                <p className='text-lg font-semibold pb-2'>
                                    {user?.firstname} {user?.lastname}
                                    {user?.superadmin && 
                                        <span className='text-xs text-lime-500 font-medium uppercase ml-2'>Superadmin</span>
                                    }
                                </p>
                                
                                <p className='text-muted'>{user?.email}</p>
                            </div>
                        </div>
                    </div>

                    <div className='mt-10'>
                        <p className='text-md pb-4'>Permessi uffici</p>
                        <div className='flex flex-col gap-4'>
                            {isLoadingPermissions && <p>Caricamento permessi...</p>}
                            {!isLoadingPermissions && offices?.length === 0 && <p>Nessun permesso ufficio assegnato.</p>}

                            {offices?.map((permission) => (
                                <div key={permission._id} className='border border-light rounded-sm p-4'>
                                    <p className='font-semibold'>{permission.element?.name}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </Container>
            </div>

            <UserEditPopup
                visible={editUserPopup}
                setVisible={setEditUserPopup}
                user={user}
            />
        </>
    )
}
